/**
 * Labels of the volume-price tiers in English, French and Spanish, for this folder's views and
 * the product page's version (`components/Product/ProductDetailMoreYouBuy/`).
 */
import { LanguageContent } from "@ryerson/frontend.common";

/** Label keys. `qty` heads the dark tier table, `quantity` the light (mobile slide-out) one. */
export interface MoreYouBuyMoreYouSaveContentProps {
	qty: string;
	quantity: string;
	price: string;
	back: string;
	theMoreYouBuyHeader: string;
	theMoreYouSaveHeader: string;
}

/** The labels by language. */
export const MoreYouBuyMoreYouSaveContent: LanguageContent<MoreYouBuyMoreYouSaveContentProps> = {
	en: {
		qty: "Qty",
		price: "Price",
		quantity: "Quantity",
		back: "Back",
		theMoreYouBuyHeader: "The More You Buy",
		theMoreYouSaveHeader: "The More You Save",
	},
	fr: {
		qty: "Qté",
		price: "Prix",
		quantity: "Quantité",
		back: "Retour",
		theMoreYouBuyHeader: "Plus Vous Achetez",
		theMoreYouSaveHeader: "Plus Vous Économisez",
	},
	es: {
		qty: "Cant.",
		price: "Precio",
		quantity: "Cantidad",
		back: "Atrás",
		theMoreYouBuyHeader: "Cuanto Más Se Compra",
		theMoreYouSaveHeader: "Más Usted Ahorra",
	},
};
